module.exports = __webpack_public_path__ + "img/7eleven.7d653aad.png";